"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSlotsToString = requestSlotsToString;
const requestSlotValueToString_1 = require("./requestSlotValueToString");
/**
 * Convert a set of slots to a string, helpful for debuging.
 *
 * @param slots
 * @returns - A string respresentation of the slot values
 */
function requestSlotsToString(slots) {
    let str = "";
    if (!slots || typeof slots !== "object") {
        return str;
    }
    const slotNames = Object.keys(slots);
    slotNames.forEach((name) => {
        const slot = slots[name];
        str += `${name}:${(0, requestSlotValueToString_1.requestSlotValueToString)(slot.value)}  `;
    });
    return str.trim();
}
//# sourceMappingURL=requestSlotsToString.js.map